import { useState, useEffect, useContext } from "react";
import { useSearchParams, Link } from 'react-router-dom';
import {Image, Loader} from "semantic-ui-react";

import SearchContext from 'src/context/SearchContext';
import SearchBox from 'src/components/SearchBox';
import Nav from 'src/components/Nav';
import 'src/css/Home.scss';

const pageSize = 15;

export default function Home() {

    const {results, search, loading, total, } = useContext(SearchContext);
    const [searchParams] = useSearchParams();
    const [items, setItems] = useState([]);

    const [page, setPage] = useState(0);
    const [load, setLoad] = useState(false);

    useEffect(() => {
        if (!loading) {
            const query = searchParams.get('query')?.trim() || '';
            const filters = Array.from(searchParams)
            setItems([]);
            search({query, filters, size: pageSize});
            setPage(0)
        }
    }, [searchParams]);

    useEffect(() => {
        // console.log(results);
        setItems(prev => page ? prev.concat(results) : results);
        setLoad(false);
    }, [results]);

    const handleScroll = () => {
        // console.log(window.innerHeight + document.documentElement.scrollTop, document.documentElement.offsetHeight - 20);
        if ((window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 20)) {
            setLoad(true);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        window.scrollTo(0, 0);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        let from = pageSize * (page + 1);
        // console.log('load', load, !loading, from, total);
        if (load && !loading && from < total) {
            const query = searchParams.get('query')?.trim() || '';
            const filters = Array.from(searchParams)
            console.log('Cargamos más', page, from, total);
            search({query, filters, size: pageSize, from});
            setPage(p => p + 1)
        }
    }, [load]);

    return (
        <main className="home">
            <div className="intro">
                <div className="title">Laboratorio virtual<br/>de patología veterinaria</div>
                <SearchBox />
                <div className="texto">
                    <p>
                        La Facultad de Medicina Veterinaria y Zootecnia de la Universidad Nacional
                        Autónoma de México presenta el laboratorio virtual de Patología Veterinaria
                        (PV), que tiene como objetivo promover las habilidades de observación y
                        reconocimiento de las lesiones microscópicas en distintos órganos, aparatos
                        y sistemas de los animales, que contribuya a la formación de los estudiantes
                        de licenciatura y posgrado.
                    </p>
                </div>
            </div>
            <Nav />
            <div className="ratio">{`Mostrando ${items.length} de ${total}`}</div>
            <div className="results">
                {items.map((item, i) => (
                    <div key={'item-' + i} className="item-card">
                        <div className="img">
                            <Image src={item.iipbigthumb} alt="Imagen"/>
                        </div>
                        <div className="label">
                            <div>{item?.caso?.titulo}</div>
                            {/* <div>{item.metadata.dc_title.value}</div> */}
                            <div>{item?.caso?.datos_animal}</div>
                        </div>
                        <Link to={`item/${item.id}`} className="no-txt link">
                            <span>{item.metadata.dc_title?.value}</span>
                        </Link>
                    </div>
                ))}
                {loading && <div className="loading"> <Loader active inline='centered'/> </div>}
            </div>
        </main>
    );
}
